import { css } from '@emotion/react';
import { Heading, Paragraph, semanticTokens, tokens } from '@flysas-tech/commercial-ui';
import { t } from 'i18n';
import { formatCurrency } from 'shared';

import { LinkAsButton } from '../atoms';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${tokens.dimension['space-4']};
  `,
  wrapper: css`
    display: flex;
    gap: ${tokens.dimension['space-3']};
    justify-content: space-between;
  `,
  price: css`
    font-weight: 700;
  `,
  detailsContainer: css`
    display: flex;
    align-items: center;
    gap: ${tokens.dimension['space-3']};
  `,
  detailsDivider: css`
    color: ${semanticTokens.color.border.subtle};
    &:after {
      content: '|';
    }
  `,
  prices: css`
    align-items: flex-end;
    display: flex;
    flex-direction: column;
  `,
};

type Props = {
  formattedTotalPrice: string;
  totalTax: number;
  travelersTypeString: string;
  pos: string;
  hasTaxBreakdown: boolean;
  formattedTotalPoints?: string;
  onClick: () => void;
};

export const CartTotal = ({
  formattedTotalPoints,
  formattedTotalPrice,
  totalTax,
  travelersTypeString,
  pos,
  hasTaxBreakdown,
  onClick,
}: Props) => {
  return (
    <div css={styles.container}>
      <div css={styles.wrapper}>
        <Heading color={'heading-primary'} as="h2" size={'title-4'}>{`${t('common:total', {
          defaultValue: 'Total',
        })}`}</Heading>
        <div css={styles.prices}>
          {formattedTotalPoints && (
            <Paragraph color="primary" size="paragraph-5" css={styles.price}>
              {formattedTotalPoints}
            </Paragraph>
          )}
          <Paragraph color="primary" size="paragraph-5" css={styles.price}>
            {formattedTotalPrice}
          </Paragraph>
        </div>
      </div>
      <div css={styles.detailsContainer}>
        <Paragraph color="primary" size="paragraph-3">
          {travelersTypeString}
        </Paragraph>
        <span css={styles.detailsDivider} />
        {hasTaxBreakdown ? (
          <LinkAsButton onClick={onClick}>
            {t('rebooking.upsell.tax', { price: formatCurrency(totalTax, pos) })}
          </LinkAsButton>
        ) : (
          <Paragraph color="primary" size="paragraph-3">
            {t('rebooking.upsell.tax', { price: formatCurrency(totalTax, pos) })}
          </Paragraph>
        )}
      </div>
    </div>
  );
};
